module.exports = __webpack_public_path__ + "static/CartStack-e56a94d61a362540a603cb37be69f324.svg";